import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const store = new Vuex.Store({
    state: {
        isLoggedIn: false,
        permissions: [],
        departments: [],
        deaneries: [],
        salutations: [],
        designations: [],
        programmeTypes: [],
        topics: [],
        batches: [],
        roles: [],
        role: null,
        miscs: [],
        misc: null,
        courses: [],
        course: null,
        papers: [],
        paper: null,
        students: [],
        all_students: [],
        student: null,
        teachers: [],
        teacher: null,
        programmes: [],
        programme: null,
        event: null,
        registrations: [],
        news: [],
        new: null,
        volumes: [],
        tree: [],
        newsletters: [],
        newsletter: null,
        notifications: [],
        notification: null,
        users: [],
        notices: [],
        notice: null,
        today: [],
        dashboard: null,
        subscribers: [],
        issueNo: 0
    },
    getters,
    mutations,
    actions
})